import { memo } from "react";
import { JobLevelBackfillPromptHost } from "./job-level-backfill/job-level-backfill-prompt-host";

export const MerchantPromptHost = memo(function MerchantPromptHost() {
  return <JobLevelBackfillPromptHost />;
});
